<template>
    <div class="curtain-grey" @click.stop="close()">
        <div class="body-day-matters" @click.stop="">
            <div class="border-day-matters">
                <div class="text-title">{{ textTitle }}</div>
                <div class="text-week">周{{ dayItem.weekday }} {{ dayItem.viceDay }}</div>
                <div class="items-matter scrollbar">
                    <template
                            v-if="matterItem.timeInfo.state <=0"
                            v-for="matterItem in dayItem.matterArray">
                        <MatterItem :matterItem="matterItem"
                                    @clockEvent="submitClock($event)"
                                    @matterEvent="submitMatter($event)"
                        />
                    </template>
                    <template
                            v-if="matterItem.timeInfo.state > 0"
                            v-for="matterItem in dayItem.matterArray">
                        <MatterItem :matterItem="matterItem"
                                    @clockEvent="submitClock($event)"
                                    @matterEvent="submitMatter($event)"
                        />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MatterItem from "@/pages/ViewModule/DayMatters/MatterItem";
export default {
    name: "DayMatters",
    components: {
        MatterItem
    },
    data(){
        return {
            textTitle: "",
        }
    },
    props: {
        dayItem: {
            type: Object,
            default: {},
        },
    },
    methods: {
        close: function(){
            this.$emit("closeEvent");
        },
        submitClock: function(e){
            this.$emit("clockEvent", e);
        },
        submitMatter: function(e){
            this.$emit("matterEvent", e);
            this.close();
        },
    },
    mounted(){
        this.textTitle = this.dayItem.date.replace("-","年").replace("-","月");
    }
}
</script>

<style scoped>
div.body-day-matters{
    width: 4.72rem;
    height: auto;
    padding: 0.08rem;
    background: #FFFFFF;
    border-radius: 0.3rem;
    margin: 20vh auto auto;
}
div.border-day-matters{
    width: 100%;
    height: auto;
    padding: 0.2rem 0 0.3rem;
    border: 0.02rem solid #000000;
    border-radius: 0.26rem;
    box-sizing: border-box;
}
div.text-title{
    width: 100%;
    height: 0.22rem;
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: center;
}
div.text-week{
    width: 100%;
    font-size: 0.18rem;
    color: #999999;
    line-height: 0.25rem;
    text-align: center;
    margin-top: 0.08rem;
}
div.items-matter{
    width: 100%;
    height: 2rem;
    margin-top: 0.1rem;
    box-sizing: border-box;
    padding: 0 0.15rem;
    overflow-y: scroll;
}
div.scrollbar{
    padding-right: 0.1rem;
    overflow-y: scroll;
}
div.scrollbar::-webkit-scrollbar{
    background: transparent;
}
</style>